import { configureStore } from '@reduxjs/toolkit'
import productSliceReducer from './modules/stability-maintenance-module/redux/productSlice'
export default configureStore({
  reducer: {
    product: productSliceReducer
  }
})
